var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m13.645 22.051-3.186-7.738 11.38-11.38-8.194 19.118zM1.95 10.355l19.118-8.193-11.38 11.38-7.738-3.187zM24 .545A.546.546 0 0 0 23.455 0a.527.527 0 0 0-.233.057L23.22.053.335 9.861c-.001 0-.003 0-.004.002l-.02.009.002.003a.543.543 0 0 0-.313.489c0 .247.168.449.394.515l-.002.008 9.01 3.71 3.71 9.011.01-.002a.538.538 0 0 0 .514.394c.217 0 .401-.129.49-.313l.003.002.008-.02a.02.02 0 0 0 .002-.004L23.947.78l-.006-.003A.525.525 0 0 0 24 .545zM8.727 18a.546.546 0 0 0-.385.16l-1.637 1.636a.545.545 0 1 0 .772.771l1.636-1.636A.546.546 0 0 0 8.727 18zm0-2.181a.546.546 0 0 0-.93-.386l-5.455 5.454a.546.546 0 0 0 .77.771l5.455-5.454a.542.542 0 0 0 .16-.385zm-3.432.385.545-.546a.546.546 0 0 0-.771-.771l-.546.546a.546.546 0 0 0 .772.77z",
    fill: "#0B80E0",
    mask: "url(#b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.1d79eaf8.svg";
export { ForwardRef as ReactComponent };